<div
  class="bg-gradient-to-r from-mbaza-primary to-mbaza-secondary min-h-screen w-screen flex flex-col justify-center items-center p-4 sm:p-6 md:p-8 relative overflow-hidden before:absolute before:inset-0 before:bg-[radial-gradient(circle,white_2px,transparent_2px)] before:bg-[length:25px_25px] before:opacity-30 before:pointer-events-none">
  <div
    class="max-w-[480px] bg-white rounded-sm shadow-md w-full sm:w-11/12 md:w-9/12 lg:w-4/12 px-6 md:px-12 py-8 sm:py-12 md:py-15 flex flex-col relative z-10">
    <div class="flex justify-center items-center">
      <app-mb-logo class="mb-2 sm:mb-4 md:mb-6" />
    </div>
    <app-login-form></app-login-form>
  </div>
  <div class="absolute bottom-0 left-0 right-0 z-10">
    <div class="flex justify-center items-center mb-4 sm:mb-6 md:mb-10">
      <span class="text-mbaza-text-light font-extralight text-sm sm:text-base">&copy; {{ currentYear }} MBAZA</span>
    </div>
  </div>
</div>

@if (loading$ | async) {
<div class="fixed inset-0 flex flex-col gap-4 justify-center items-center bg-white z-50">
  <nz-spin></nz-spin>
  <p class="text-mbaza-text-dark font-bold">Signing you in...</p>
</div>
}